/*
 * BrightLabs Proprietary Limited (c) 2021
 * https://www.brightlabs.co.bw
 * info@brightlabs.co.bw
 */

import React from "react";
import {Stack} from "@fluentui/react";
import Slide from 'react-reveal';

import hero from "../../images/illustrations/consultation.svg";

import Page from "../shared/Page";
import ResizablePage from "../shared/ResizablePage";
import helpers from "../../k/helpers";
import Hero from "../shared/Hero";


class HeroContent extends React.Component<any, any> {

    public render() {

        const
            padding = helpers.padding();

        return (
            <Stack tokens={{childrenGap: padding}}>

                <Stack>

                    <Slide left>
                        <Stack tokens={{childrenGap: -16}}>
                            <h4>
                                Consultation
                            </h4>

                            <h1>
                                {helpers.links.consultation.text}
                            </h1>
                        </Stack>
                    </Slide>

                    <Slide right>
                        <h2>
                            Book a free 30 minute* consultation about your project.
                        </h2>
                    </Slide>

                </Stack>

                <Slide bottom>
                    <Stack verticalFill={true} verticalAlign={'center'} horizontalAlign={'center'}>
                        <h3>
                            Let's connect via Microsoft Teams.<br />
                            <span style={{textDecoration: "underline"}}>sales@brightlabs.co.bw</span>
                        </h3>
                    </Stack>
                </Slide>

            </Stack>
        );
    }
}

class AdditionalContent extends React.Component<any, any> {
    render() {
        return null;
    }
}

export default class Consultation extends ResizablePage {

    public render() {

        const
            backgroundColor = 'rgba(0, 0, 0, 0.003)',
            backgroundSize = '30%',

            title = "BrightLabs | " + helpers.links.consultation.text,
            url = helpers.links.consultation.url,
            description = "Get a consultation about your project " +
                "- UX/UI design, web and mobile development, Office 365.";

        return (
            <Page title={title} description={description} url={url}>

                <Hero backgroundColor={backgroundColor} backgroundSize={backgroundSize} hero={hero}>
                    <HeroContent />
                </Hero>

                <AdditionalContent />
            </Page>
        );
    }
}
